import React, { useCallback, useEffect, useState } from 'react';

import { CircularProgress, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import useBlocRefHook from '../../utils/useBlocRef.hook';

const useStyles = makeStyles(() => {
  return {
    paragraph: {
      color: '',
      fontSize: '24px',
      fontWeight: 'bold',
    },

    root: {
      alignItems: 'center',
      display: 'flex',

      justifyContent: 'center',
      minHeight: '100vh',
      padding: '24px',
    },
  };
});

export default () => {
  const blocRef = useBlocRefHook('confirmTokenBloc');
  const classes = useStyles();
  const history = useHistory();

  const [loading, setLoading] = useState();
  const [redirectTo, setRedirectTo] = useState();
  const [message, setMessage] = useState();
  const [success, setSuccess] = useState();

  const handleProcessToken = useCallback(async () => {
    const query = new URLSearchParams(window.location.search);
    const token = query.get('token');

    await blocRef.current.confirmToken(token);
  }, []);

  useEffect(() => {
    const loadingSub = blocRef.current.loading$.subscribe(setLoading);
    const redirectToSub = blocRef.current.redirectTo$.subscribe(setRedirectTo);
    const messageSub = blocRef.current.message$.subscribe(setMessage);
    const successSub = blocRef.current.success$.subscribe(setSuccess);

    handleProcessToken();

    return () => {
      loadingSub.unsubscribe();
      redirectToSub.unsubscribe();
      messageSub.unsubscribe();
      successSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (redirectTo) {
      history.push(redirectTo);
    }
  }, [redirectTo, history]);

  return (
    <div className={classes.root}>
      <div>
        <CircularProgress />

        <h1 style={{ fontSize: '16px', marginBottom: 0, marginTop: '8px' }}>LOADING</h1>
      </div>
    </div>
  );
};
